import { Close } from '@mui/icons-material';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';

import SelectPaymentAccount from '@/routes/Agency/Account/PaymentSection/SelectPaymentAccount';

const SelectAccountModal = ({
  achConfig,
  hideAccountModal,
  handleSelect,
}: any) => {
  return (
    <Dialog fullWidth={true} maxWidth={'sm'} open={true}>
      <DialogTitle id="customized-dialog-title" sx={{ m: 0, p: 2 }}>
        Select Account
      </DialogTitle>
      <IconButton
        aria-label="close"
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
        onClick={hideAccountModal}
      >
        <Close />
      </IconButton>
      <DialogContent>
        {achConfig && (
          <SelectPaymentAccount
            achConfig={achConfig}
            handleSelect={handleSelect}
            onCloseEditor={hideAccountModal}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default SelectAccountModal;
